import React, { useEffect, useState, useContext } from "react";
import { Card, Col, Row, Typography, Button, Modal, Tooltip, Input, Form } from "antd";
import { AppStateContext } from "../../context/AppContext";
import lang from "../../helper/lang";
import FAQForm from "../../components/FaqForm";
import { Severty, ShowToast } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import DeleteModal from "../../components/DeleteModel";

const { Title } = Typography;
const FAQ = () => {
  const { setPageHeading } = useContext(AppStateContext);
  const { request } = useRequest();
  const [showDelete, setShowDelete] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [selected, setSelected] = useState();
  const [faqs, setFaqs] = useState([]);
  const [editQuestion, setEditQuestion] = useState(""); // State for editable question
  const [editAnswer, setEditAnswer] = useState(""); // State for editable answer

  useEffect(() => {
    setPageHeading(lang("FAQ"));
    fetchFAQs();
  }, [setPageHeading, refresh]);

  const fetchFAQs = async () => {
    request({
      url: "/admin/faq",
      method: "get",
      onSuccess: (data) => {
        setFaqs(data.data);
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const onDelete = (id) => {
    request({
      url: `/admin/faq/${id}`,
      method: "DELETE",
      onSuccess: (data) => {
        setLoading(false);
        setRefresh((prev) => !prev);
        ShowToast("FAQ Deleted Successfully", Severty.SUCCESS);
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  // Edit FAQ 
  const handleEdit = (faq) => {
    setShowEdit(true);
    setSelected(faq._id);
    setEditQuestion(faq.question);
    setEditAnswer(faq.answer);
  };

  const handleEditSubmit = async () => {
    if (selected) {
      request({
        url: `/admin/faq/${selected}`,
        data: { question: editQuestion, answer: editAnswer },
        method: "PUT",
        onSuccess: (data) => {
          ShowToast("FAQ Updated Successfully", Severty.SUCCESS);
          setRefresh((prev) => !prev); // Refresh the FAQ list
          setShowEdit(false); // Close the edit modal
        },
        onError: (error) => {
          console.log(error);
          ShowToast(error, Severty.ERROR);
        },
      });
    }
  };

  const handleFAQSubmit = async (newFaqs) => {
    try {
      request({
        url: "/admin/faq",
        data: { question: newFaqs },
        method: "post",
        onSuccess: (data) => {
          ShowToast("FAQ Added Successfully", Severty.SUCCESS);
          setFaqs([...faqs, ...data.data]);
          fetchFAQs();
        },
        onError: (error) => {
          console.log(error);
          ShowToast(error, Severty.ERROR);
        },
      });
    } catch (error) {
      console.error("Error submitting FAQs:", error);
    }
  };

  return (
    <>
      <div className="faq-form-wrap faq-button-qq" style={{ padding: "16px" }}>
        <Card>
          <Title level={2}>FAQ Management</Title>
          <FAQForm onSubmit={handleFAQSubmit} />

          <div style={{ marginTop: "24px" }}>
            <Title level={3}>FAQ</Title>
            {faqs.map((faq, index) => (
              <div key={index} style={{ marginBottom: "10px", margin: "16px" }}>
                <Row gutter={[24, 24]}>
                  <Col span={24} md={16}>
                    <Card bordered={true}>
                      <p>
                        <strong>Ques:</strong> {faq.question}
                      </p>
                      <p>
                        <strong>Ans:</strong> {faq.answer}
                      </p>
                      <div className="main-new-edit-button-in-faqq">
                        <Tooltip title={lang("Delete")} color={"black"}>
                          <Button
                            type="primary ant-btn main-deletebutton-faq-3"
                            danger
                            onClick={() => {
                              setShowDelete(true);
                              setSelected(faq._id);
                            }}
                            loading={loading}
                          >
                            <DeleteOutlined />
                          </Button>
                        </Tooltip>
                        <Tooltip title={lang("Edit")} color={"black"}>
                          <Button
                            type="primary ant-btn main-deletebutton-faq-3"
                            onClick={() => handleEdit(faq)}
                            loading={loading}
                            danger
                          >
                            <EditOutlined />
                          </Button>
                        </Tooltip>
                      </div>
                    </Card>
                  </Col>
                </Row>
              </div>
            ))}
          </div>
        </Card>
      </div>

      {showDelete && (
        <DeleteModal
          title={"Delete FAQ"}
          subtitle={`Are you sure you want to delete this FAQ?`}
          show={showDelete}
          hide={() => {
            setShowDelete(false);
            setSelected(null);
          }}
          onOk={() => {
            onDelete(selected);
          }}
        />
      )}


      <Modal
        title="Edit FAQ"
        visible={showEdit}
        onOk={handleEditSubmit}
        onCancel={() => {
          setShowEdit(false);
          setSelected(null);
          setEditQuestion("");
          setEditAnswer("");
        }}
      >
        <Form>
          <Form.Item label="Question" className="new-faq-modal-class">
            <Input
              placeholder="Question"
              value={editQuestion}
              onChange={(e) => setEditQuestion(e.target.value)}
              style={{ marginTop: 5 }}
            />
          </Form.Item>

          <Form.Item label="Answer" className="new-faq-modal-class">
            <Input.TextArea
              placeholder="Answer"
              value={editAnswer}
              onChange={(e) => setEditAnswer(e.target.value)}
              style={{ marginTop: 5, minHeight: 150 }}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default FAQ;
